import type { NuxtAxiosInstance } from '@/types/axios'
import utils from '@/utils'

interface FacebookLoginPayload {
  fbToken: string
  id: string
}

export async function facebookLogin(axios: NuxtAxiosInstance, { fbToken, id }: FacebookLoginPayload): Promise<any> {
  const res = await axios.$post('/fblogin', {
    fbToken,
    fbId: id,
    os: 'web',
    osVersion: window.navigator.userAgent,
    appVersion: '1.0',
    deviceId: utils.UUID,
  })

  if (res.code !== 0) {
    throw res
  }

  return res
}

interface RegisterData {
  email: string
  name: string
  gender: number | null
  birthday: string
  osVersion: string
  deviceId: string
  fbId?: string
  fbToken?: string
  userContract?: {
    isTermsAccepted: boolean
    isMarketingAllowed: boolean
  }
}
interface RegisterOptions {
  byFacebook?: boolean
}

export async function register(axios: NuxtAxiosInstance, data: RegisterData, options: RegisterOptions = { byFacebook: false }): Promise<any> {
  try {
    const defaultData = {
      ...data,
      fromFacebook: options.byFacebook ?? false,
      os: 'web',
      appVersion: '1.0',
    }
    const registerData = Object.assign(defaultData, data)

    const res = await axios.$post('/register', registerData)
    if (res.code !== 0) {
      throw res
    }

    return res
  } catch (error) {
    console.error('register by facebook err: ', error)
    throw error
  }
}

export async function getZendeskJwt(axios: NuxtAxiosInstance): Promise<any> {
  const res = await axios.$get('/zendesk/token')
  return res
}
